import gql from 'graphql-tag'

export const GET_NOTIFICATION_LIST_QUERY = gql`
  query notification_list {
    notification_list @rest(type: "NotificationList", path: "/notification-list") {
      id
      user_uuid
      active
      channels
      log_filter {
        type
        lang
        sources {
          model_id
          model_name
        }
      }
    }
  }
`
